import { createStandardAction } from 'typesafe-actions'
import { DocumentInfo } from '../document/actions'
import { WfeLS } from './types'

export type CheckFromLocalStoragePayload = WfeLS | DocumentInfo

export const PERSIST_TO_LOCAL_STORAGE = 'session/PERSIST_TO_LOCAL_STORAGE'
export const LOAD_DOCUMENT_FROM_LOCAL_STORAGE = 'session/LOAD_DOCUMENT_FROM_LOCAL_STORAGE'
export const CLEAR_LOCAL_STORAGE = 'session/CLEAR_LOCAL_STORAGE'
export const LOAD_FROM_LOCAL_STORAGE = 'session/LOAD_FROM_LOCAL_STORAGE'
export const CHECK_FROM_LOCAL_STORAGE = 'session/CHECK_FROM_LOCAL_STORAGE'
export const REHYDRATE_WORKSPACE = 'session/REHYDRATE_WORKSPACE'
export const SET_RECIEVED_PLAGIARISM_COMMENTS = 'session/SET_RECIEVED_PLAGIARISM_COMMENTS'

export const persistToLocalStorage = createStandardAction(PERSIST_TO_LOCAL_STORAGE)()
export const clearLocalStorage = createStandardAction(CLEAR_LOCAL_STORAGE)()
export const loadFromLocalStorage = createStandardAction(LOAD_FROM_LOCAL_STORAGE)<WfeLS>()
export const checkFromLocalStorage = createStandardAction(CHECK_FROM_LOCAL_STORAGE)<
  CheckFromLocalStoragePayload
>()
export const rehydrateWorkspace = createStandardAction(REHYDRATE_WORKSPACE)()



// WEBPACK FOOTER //
// ./src/state/session/actions.ts